<template>
	<div class="">
		<div class="back-arrow pl-6 pt-2">
			<router-link :to="`/theme/${$route.params.id}/page/${pageId}`">
				<i class="fa fa-fw fa-arrow-left" />
				<span> Back to page edit </span>
			</router-link>
		</div>
		<base-page-heading
			title="Object Edit Page"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="btnShow"
					type="submit"
					size="lg"
					variant="secondary"
					@click="updateObjectEditProperties"
				>
					Save changes
				</b-button>
			</template>
		</base-page-heading>

		<div class="row content">
			<PageObjectEditTable
				ref="objecteditpage"
				:page-id="$route.params.pageid"
				:object-id="$route.params.objectid"
			/>
		</div>
	</div>
</template>

<style scoped>
.back-arrow{
	background-color: #f6f7f8;
}
</style>
